import ImageIcon from '@mui/icons-material/Image';
import { Button, Grid, MenuItem, TextField, Tooltip } from "@mui/material";
import Box from "@mui/material/Box";
import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../../store";
import { addAgent } from "../../store/siteWebSlice";
import { SITEWEB_SERVER_BASE_URL, apiClient } from "../../util/apiClient";
import { convertToBase64, errorNotify, successNotify } from "../../util/functions";
import PostDialog from "../components/PostDialog";
import { IAgentState, IPayloadAgent } from "./interface";

interface IAddProps {
  agentState: IAgentState;
  setAgentState: (x: IAgentState) => void
  selectedPhoto: any;
  setSelectedPhoto: (x: any) => void
  image: string;
  setImage: (x: string) => void
}


const Add = (props: IAddProps) => {

  //props
  const {
    agentState,
    setAgentState,
    setSelectedPhoto,
    image,
    setImage
  } = props

  //redux
  const { fonctions, services } = useSelector((state: IReduxState) => state.siteWeb);


  //hooks
  const selectPhoto: any = useRef(null);


  //fonctions
  const handleInputChange = (e: any) => {
    const { value, name } = e.target
    setAgentState({ ...agentState, [name]: value })
  }


  return (
    <Box sx={{ flexGrow: 1, width: "100%" }}>
      <Grid
        container
        spacing={1}
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Grid item md={3} xs={12} sm={3}>
          <Grid
            container
            spacing={2}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <Grid item md={12} xs={12} sm={12}>
              <div style={{ width: "15vw", height: "30vh", border: "1px solid gray" }}>
                <img
                  src={image}
                  style={{ width: "15vw", height: "30vh" }}
                />
              </div>
            </Grid>
            <Grid item md={12} xs={12} sm={12}>
              <Tooltip title="Charger l'image descriptive de l'actualité">
                <Button
                  variant="outlined"
                  color="primary"
                  component="label"
                  startIcon={<ImageIcon />}
                  style={{ marginTop: 10 }}
                  onClick={() => {
                    selectPhoto?.current?.click();
                  }}
                >
                  Charger la photo
                </Button>
              </Tooltip>
              <input
                hidden
                multiple
                type="file"
                name="pieceJointe"
                ref={selectPhoto}
                onChange={(e: any) => {
                  const files = e.target.files[0];
                  if (files) {
                    const img = URL.createObjectURL(files);
                    setImage(img);
                    setSelectedPhoto(e.target.files[0]);
                  }
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <Grid
            container
            spacing={2}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <Grid item md={12} xs={12} sm={12}>
              <TextField
                fullWidth
                size="small"
                name="nomAgent"
                label="Nom complet"
                value={agentState.nomAgent}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item md={12} xs={12} sm={12}>
              <TextField
                fullWidth
                select
                size="small"
                name="idFonction"
                label="Fonction"
                value={agentState.idFonction}
                onChange={handleInputChange}
              >
                {fonctions.map((option) => (
                  <MenuItem key={option.idFonction} value={option.idFonction}>
                    {option.fonctionAgent}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item md={12} xs={12} sm={12}>
              <TextField
                fullWidth
                select
                size="small"
                name="idService"
                label="Service"
                value={agentState.idService}
                onChange={handleInputChange}
              >
                {services.map((option) => (
                  <MenuItem key={option.idService} value={option.idService}>
                    {option.libService}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

const initialState: IAgentState = {
  nomAgent: "",
  idFonction: null,
  idService: null
}

const DialogAdd = () => {

  //redux
  const dispatch = useDispatch();

  //hooks
  const [open, setOpen] = useState<boolean>(false)
  const [addLoading, setAddLoading] = useState<boolean>(false)
  const [agentState, setAgentState] = useState<IAgentState>(initialState)
  const [selectedPhoto, setSelectedPhoto] = useState<any>({})
  const [image, setImage] = useState<string>("");

  //Fermer la boite de dialog d'ajout d' un agent
  const onClose = () => {
    setOpen(false)
  }

  //Ouvrir la boite de dialog d'ajout d' un agent
  const handleOpenDialog = () => {
    setOpen(true)
  }

  //Enregistrer un agent dans la bd
  const handleSave = async (e: any) => {
    try {
      e.preventDefault()
      setAddLoading(true)
      //Obtenir l'image de l'agent en base 64
      const actualiteImageEnBase64 = selectedPhoto ? await convertToBase64(selectedPhoto) : "";
      //Constituer le payload final
      const apiPayload: IPayloadAgent = {
        ...agentState,
        agentImageEnBase64: actualiteImageEnBase64,
      }
      // Envoi de la requête vers l'api 
      const res: any = await apiClient.post(
        SITEWEB_SERVER_BASE_URL,
        "/ajouteragent",
        apiPayload
      );
      if (res.status === 1) {
        dispatch(addAgent(res.data))
        successNotify("Action effectuée avec succès");
        setAddLoading(false)
        setAgentState(initialState)
        setImage("")
      } else {
        errorNotify("Erreur");
        setAddLoading(false)
      }
    } catch (error) {
      console.log("🚀 ~ file: Add.tsx:252 ~ handleSave ~ error:", error)
      setAddLoading(false)
    }
  }


  return (
    <PostDialog
      onClose={onClose}
      open={open}
      dialogContent={
        <Add
          agentState={agentState}
          setAgentState={setAgentState}
          selectedPhoto={selectedPhoto}
          setSelectedPhoto={setSelectedPhoto}
          image={image}
          setImage={setImage}
        />}
      actionFunc={handleSave}
      title="Agent"
      addLoading={addLoading}
      handleOpenDialog={handleOpenDialog}
    />

  );
};
export default DialogAdd;



